import { render, staticRenderFns } from "./savings.vue?vue&type=template&id=6fd52e20"
import script from "./savings.vue?vue&type=script&lang=js"
export * from "./savings.vue?vue&type=script&lang=js"
import style0 from "./savings.vue?vue&type=style&index=0&id=6fd52e20&prod&lang=scss"
import style1 from "../../../assets/styles/v2/common.scss?vue&type=style&index=1&prod&lang=scss&external"
import style2 from "../main.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports